import React, { Fragment, useEffect, useState } from "react";
import * as configApi from '../../config/configApi.js';
import Slider from "react-slick";
import SimpleReactValidator from 'simple-react-validator';
import bg1 from "../../assets/utils/images/originals/city.jpg";
import bg2 from "../../assets/utils/images/originals/citydark.jpg";
import bg3 from "../../assets/utils/images/originals/citynights.jpg";
import { connect } from 'react-redux';
import {
  Col,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  InputGroup, InputGroupAddon, InputGroupText
} from "reactstrap";

import history from '../../stores/history';
import { store } from '../../stores';
import ApiCaller from "../../lib/ApiCaller";
import {
    ToastContainer,
    toast
} from "react-toastify";
import  "./index.css";
import 'react-toastify/dist/ReactToastify.css';
import { message } from "antd";
import { withTranslation } from "react-i18next";
import i18n from "../../i18n";
import languages from "../../config/languages";
import { get, map } from "lodash";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const LoginValidator = new SimpleReactValidator();

function handleSubmit(username, password, props) {
    if (LoginValidator.allValid()) {
        const notify = (msg) => toast(msg || props.t("Login failed") , {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });;
        ApiCaller.post("/LoginViewResult/SignInWebResult", { UserName: username, Password: password })
            .then(res => {
                if (res.data.isSuccess) {
                    let token = '';
                    let name = '';
                    let userID = '';
                    let groupid = '';
                    let title = '';
                    let typeUser = '';
                    if (res.data.token) {
                        token = res.data.token
                        name = res.data.name || ''
                        userID = res.data.userID || ''
                        title = res.data.title || ''
                        typeUser = res.data.typeUser || ''
                    }
                    localStorage.setItem('token', token);
                    localStorage.setItem('name', name);
                    localStorage.setItem('userID', userID);
                    localStorage.setItem('typeUser', typeUser);
                    store.dispatch({
                        type: 'USER_SET_DATA', 
                        data: {
                            token: res.data.token, 
                            name: name, 
                            userID: userID,
                            typeUser: typeUser
                        }
                    });
                    // const from = '';
                    // if (props.location.state) {
                    //     from = props.location.state.from;
                    // }
                    
                    // if (from !== '' && from !== undefined) {
                    //     history.push(from);
                    // }
                    if (typeUser === 1 ) {
                        history.push('/dashboard');
                        message.success(props.t("Welcome to the Admin Dashboard!"))
                    }
                    else if (typeUser === 2 || typeUser === 3 || typeUser === 4) {
                        history.push('/');
                        message.success(props.t("Welcome to the Results Page!"))
                    }
                    else
                    {
                        history.push('/v');
                        message.success(props.t("Welcome to the Results Page!"))
                    }
                } else {
                    if (res.data?.err?.message) {
                        notify(res.data.err.message);
                    }
                }
            })
    } else {
        LoginValidator.showMessages();
    }
}
const useForceUpdate = () => {
    const [count, setCount] = useState(0)

    const increment = () => setCount(prevCount => prevCount + 1)
    return [increment, count]
}

function checkprops(props) {

    if (props === undefined || props.global === undefined || props.global.token === undefined) return
    if (props && props.global.token !== '') {
        if (props.location && props.location.state) {
            const { from } = props.location.state;
            if (from !== '' && from !== undefined) {
                history.push(from);
            } else {
                history.push('/');
            }
        } else {
            history.push('/');
        }
    }
}

function RenderPageLogin(props) {
    const primaryColor = configApi.USE_COLOR;
    const loginNote = configApi.LOGIN_NOTE;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [forceUpdate] = useForceUpdate()
    const [menu, setMenu] = useState(false);
    const passwordInputRef = React.createRef();
    const [selectedLang, setSelectedLang] = useState("");
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        const currentLanguage = localStorage.getItem("I18N_LANGUAGE");
        setSelectedLang(currentLanguage);
      }, []);
      const changeLanguageAction = (lang) => {
        //set language as i18n
        i18n.changeLanguage(lang);
        localStorage.setItem("I18N_LANGUAGE", lang);
        setSelectedLang(lang);
        window.location.reload();
      };

      const toggle = () => {
        setMenu(!menu);
      };
    const onClickHandler = e => {
        forceUpdate()
    }
    useEffect(() => {
        checkprops(props);
    }, []);
    let settings = {
        dots: true,
        infinite: true,
        speed: 500,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        initialSlide: 0,
        autoplay: true,
        adaptiveHeight: true,
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            if (!username) {
                toast.error(props.t("Please enter your account"), {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                return; 
            }
            if (!password) {
                toast.error(props.t("Please enter your password"), {
                    position: "top-right",
                    autoClose: 1000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                if (passwordInputRef.current) {
                    passwordInputRef.current.focus();
                }
                return;
            }
            handleSubmit(username, password, props);
        }
    };
    
    return (
      <Fragment>
        <ToastContainer />
        <div
          className="h-100 login-background"
          style={{
            backgroundImage: "url(/images/bg_view.jpg)",
          }}
        >
          <Row className="h-100 no-gutters">
            <Col lg="3" className="d-none d-lg-block"></Col>
            <Col
              lg="6"
              md="12"
              className="h-100 d-flex bg-white justify-content-center align-items-center"
              id="loginNotBG"
            >
              <Col lg="6" md="10" sm="12" className="mx-auto app-login-box" 
              style={{backgroundColor: "white",borderStyle: "dashed",padding:"10px",borderColor:primaryColor}}>
                {/* <div className="app-logo" /> */}
                <h4 className="mb-0">
                  <div
                    style={{ color: primaryColor, opacity: "1" }}
                    className="HeaderTitle"
                  >
                    {props.t("RESULT LOOKUP WEBSITE")}
                  </div>
                  <span>{props.t("Please log in to your account")}</span>
                </h4>
                <Dropdown
                  isOpen={menu}
                  toggle={toggle}
                  className="d-inline-block"
                >
                  <DropdownToggle className="btn header-item " tag="button">
                    <img
                      src={get(languages, `${selectedLang}.flag`)}
                      alt="Skote"
                      height="16"
                      className="me-1"
                    />
                  </DropdownToggle>
                  <DropdownMenu className="language-switch dropdown-menu-end">
                    {map(Object.keys(languages), (key) => (
                      <DropdownItem
                        key={key}
                        onClick={() => changeLanguageAction(key)}
                        className={`notify-item ${
                          selectedLang === key ? "active" : "none"
                        }`}
                      >
                        <img
                          src={get(languages, `${key}.flag`)}
                          alt="Skote"
                          className="me-1"
                          height="12"
                        />
                        <span
                          className="align-middle"
                          style={{ paddingLeft: 10, paddingBottom: 4 }}
                        >
                          {get(languages, `${key}.label`)}
                        </span>
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                <Row className="divider" />
                <div>
                  <Form onKeyDown={handleKeyDown}>
                    <Row form>
                      <Col md={12}>
                        <FormGroup>
                          <Input
                            onChange={(e) => {
                              setUsername(e.target.value);
                            }}
                            type="Username"
                            name="Username"
                            id="Username"
                            placeholder={props.t(
                              "Account: Enter your account here..."
                            )}
                          />
                          {LoginValidator.message(
                            "Username",
                            username,
                            "required"
                          )}
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row form>
                      <Col md={12}>
                        <FormGroup>
                          <InputGroup>
                          <Input
                            onChange={(e) => {
                              setPassword(e.target.value);
                            }}
                            type={showPassword ? "text" : "password"}
                            name="password"
                            id="examplePassword"
                            placeholder={props.t(
                              "Password: Enter your password here..."
                            )}
                          />
                          <InputGroupAddon addonType="append">
                              <InputGroupText style={{ cursor: "pointer" }} onClick={() => setShowPassword(!showPassword)}>
                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                              </InputGroupText>
                            </InputGroupAddon>
                          </InputGroup>
                          {LoginValidator.message(
                            "password",
                            password,
                            "required"
                          )}
                        </FormGroup>
                      </Col>
                    </Row>

                    {loginNote && (
                      <div
                        className="my-3"
                        style={{
                          ...(loginNote?.style || { color: "#dc2626" }),
                        }}
                      >
                        * {props.t(loginNote?.title)}
                      </div>
                    )}

                    <FormGroup onKeyDown={handleKeyDown}>
                      <Button
                        className="hover"
                        style={{
                          width: 100 + "%",
                          backgroundColor: primaryColor,
                          border: "none",
                        }}
                        size="lg"
                        onClick={() => {
                          handleSubmit(username, password, props);
                          forceUpdate();
                        }}
                      >
                        {props.t("LogIn")}
                      </Button>
                    </FormGroup>
                    <Row className="divider" />
                  </Form>
                </div>
              </Col>
            </Col>
          </Row>
        </div>
      </Fragment>
    );
}


function mapStateToProps(state, props) {
    return {
        global: state.global
    };
}

export default withTranslation(["dashboard"])(RenderPageLogin);